import { CachePolicies } from '@wetransfer/transfer/apollo-api/src';

export const policies: CachePolicies = {
  Metadata: {
    merge: true,
  },
};
